import React from 'react';

const TemplatesIcon = (props) => (

  <svg width="21" height="24" viewBox="0 0 21 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M15.2727 0H2.18182C0.981818 0 0 0.981818 0 2.18182V17.4545H2.18182V2.18182H15.2727V0ZM14.1818 4.36364H6.54545C5.34545 4.36364 4.37455 5.34545 4.37455 6.54545L4.36364 21.8182C4.36364 23.0182 5.33454 24 6.53454 24H18.5455C19.7455 24 20.7273 23.0182 20.7273 21.8182V10.9091L14.1818 4.36364ZM6.54545 21.8182V6.54545H13.0909V12H18.5455V21.8182H6.54545Z" fill="currentColor" />
  </svg>
);

export default TemplatesIcon;
